import { dateFormatter2 as dateFormatter, DateFormatTypes, isEmpty } from '@jfs/utils'
import { parsePage } from './TransactionsParser'

const refundParserTxnV3 = (data: any, trxType: string) => {
  const { content, page } = data
  const pageData = parsePage(page, true)

  const refundData = content.map((item) => {
    return {
      id: item?.transactionId ?? 'NA',
      date: `${dateFormatter(item?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY)}*${
        item?.transactionDateTime
      }`, //Storing both formats needed for LIST UI and to send in API separated by *
      timestamp: dateFormatter(item?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
      ern: item?.invoice ?? 'NA',
      amount: item?.transactionAmount ?? 0,
      authCode: item?.authCode ?? 'NA',
      bankRefNumber: item?.issRefData ?? 'NA',
      rrn: item?.transactionId ?? 'NA',
      txnType: trxType,
      originalTransactionId: item?.originalTransactionId ?? 'NA',
      refund: {
        amount: item?.refundAmount ?? 0,
        requestedDate: dateFormatter(item?.refundRequestedDate ?? 'NA', DateFormatTypes.DATE_ONLY),
        processdDate: dateFormatter(item?.refundProcessedDate ?? 'NA', DateFormatTypes.DATE_ONLY),
        status: item?.refundStatus ?? 'NA',
      },
      payment: {
        paymentMode: item?.cardType ?? 'NA',
        paymentType: item?.paymentType ?? 'NA',
        accountNumber: item?.accoundNumber ?? 'NA',
      },
      customer: {
        id: item?.customerId ?? 'NA',
        name: !isEmpty(item?.customerName) ? item?.customerName : 'NA',
        mobileNumber: item?.mobileNumber ?? 'NA',
        email: item?.email ?? 'NA',
      },
      merchantReferenceNumber: item?.merchantReferenceNumber ?? 'NA',
      refundReferenceNumber: item?.refundReferenceNumber ?? 'NA',
    }
  })

  return { page: pageData, refunds: refundData }
}

const refundParserTxnV3New = (data: any, txnType: string) => {
  const { content, page } = data
  const pageData = parsePage(page, true)
  const refundData = content?.map((txnItem: any) => ({
    ...txnItem,
    txnType,
    transactionDateTime: `${dateFormatter(txnItem?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY)}`,
    refundRequestedDate: `${dateFormatter(txnItem?.refundRequestedDate ?? 'NA', DateFormatTypes.DATE_ONLY)}`,
  }))

  return { page: pageData, refunds: refundData }
}

export { refundParserTxnV3, refundParserTxnV3New }
